<template>
    <div v-if="!acceptedCookie" id="notification-container" class="w-100" >
        <div class="w-100">
            <div class="d-flex justify-center">
                <h4>Questo sito utilizza cookie tecnici per migliorare la tua navigazione e cookie di terze parti: proseguendo con la navigazione consenti al loro impiego.</h4>
            </div>
            <div class="d-flex justify-content-around">
                <a
                    class="privacyButton"
                    aria-label="vai all'informativa PRIVACY"
                    @click="goToPrivacy">
                    VAI ALL'INFORMATIVA PRIVACY
                </a>
                <a
                    class="privacyButton acceptButton"
                    aria-label="ACCETTA"
                    @click="closeNotification">
                    ACCETTA
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import router from "@/router";
    import { mapGetters } from "vuex";

    export default {
        name: "CookieNotification",
        computed: {
            ...mapGetters({ 
                acceptedCookie: "acceptedCookie",
            })
        },
        methods: {
            closeNotification() {
                this.$store.commit("acceptCookie");
            },
            goToPrivacy() {
                router.push("/privacy");
            }
        },
    }
</script>
<style scoped>
#notification-container {
    display: flex;
    position: fixed;
    align-items: center;
    bottom: 10%;
    z-index: 100;
    color: white;
    padding: 2em;
    height: 10%;
    background-color: black;
    min-height: 100px;
}
.w-100 {
    width: 100%;
}
.justify-content-around {
    justify-content: space-evenly;
}
.justify-center {
    justify-content: center;
}
.d-flex {
    display: flex;
}
.privacyButton {
    border: 2px solid lightseagreen;
    border-radius: 10px;
    background-color: lightseagreen;
    font-weight: bolder;
    padding: 0.5em;
    margin-top: 0.6em;
    margin-bottom: 0.3em;
    color: black;
}
.privacyButton:hover {
  background-color: darkcyan;
}
@media all and (min-width: 430px) and (max-width: 900px) {
    #notification-container {
        height: 15%;
        min-height: 130px;
    }
}
@media all and (min-width: 320px) and (max-width: 430px) {
    #notification-container {
        height: 17%;
        min-height: 150px;
    }
    .privacyButton {
        font-size: 12px;
        border-radius: 5px;
        padding: 0.2em;
        margin-top: 0.2em;
        margin-bottom: 0.1em;
    }
}
@media all and (max-width: 320px) {
    #notification-container {
        height: 25%;
        min-height: 160px;
    }
    .privacyButton {
        font-size: 12px;
        border-radius: 5px;
        padding: 0.2em;
        margin-top: 0.2em;
        margin-bottom: 0.1em;
    }
}
</style>